module.exports = __webpack_public_path__ + "img/6.831bc4fb.jpg";